export default __webpack_public_path__ + "static/media/girl-1.29f19d1f.png";